import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationComponent } from './authentication/authentication.component';
import { FullLayoutComponent } from './shared/layouts/full-layout/full-layout.component';
import { Full_Content_Routes } from './shared/routes/full-content.routes';
import { AuthGuardService } from './shared/services/authentication/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: AuthenticationComponent, canActivate: [AuthGuardService] }, //
  { path: '', component: FullLayoutComponent, children: Full_Content_Routes, canActivateChild: [AuthGuardService] }, //
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy',
    onSameUrlNavigation: 'reload',
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
